import { isDefined } from "@clipboard-health/util-ts";
import { IonIcon } from "@ionic/react";
import { FACILITY_VIDEO_USER_EVENTS, TRACK_EVENT_SCREENS } from "@src/app/videoPlayer/constants";
import { FullScreenVideoPlayer } from "@src/app/videoPlayer/FullScreenVideoPlayer";
import { FacilityPhoto } from "@src/appV2/Facilities/types";
import { logEvent } from "@src/appV2/lib/analytics";
import { PlayerEventType, PlayerState } from "amazon-ivs-player";
import { Carousel } from "antd";
import { play as playIcon } from "ionicons/icons";
import { useCallback, useState } from "react";
interface FacilityPhotosDetails {
  facilityPhotos: FacilityPhoto[];
  facilityStreetImgUrl: string;
  facilityVideoUrl?: string;
  facilityName?: string;
  facilityUserId?: string;
}
export function FacilityPhotos(props: FacilityPhotosDetails) {
  const { facilityPhotos, facilityStreetImgUrl, facilityVideoUrl, facilityName, facilityUserId } =
    props;
  const [showFacilityVideo, setShowFacilityVideo] = useState<boolean>(false);

  const logVideoEvent = useCallback(
    (eventType: PlayerEventType | PlayerState) => {
      const eventName = FACILITY_VIDEO_USER_EVENTS[eventType];
      if (isDefined(eventName)) {
        logEvent(eventName, {
          facilityUserId,
          screen: TRACK_EVENT_SCREENS.FACILITY_PROFILE,
        });
      }
    },
    [facilityUserId]
  );

  if (!facilityPhotos.length && !facilityStreetImgUrl) {
    return null;
  }

  return (
    <>
      {facilityPhotos.length ? (
        <Carousel style={{ height: "70%" }}>
          {facilityPhotos
            .filter((photo) => isDefined(photo.url))
            // FIXME: this sorting logic should be done on the backend
            .sort((a, b) => Number(a.index) - Number(b.index))
            .map((photo) => {
              return (
                <div key={photo.url} className="imgCarouselBk">
                  <img alt="Facility Photos" src={photo.url} className="imgCarousel" />
                </div>
              );
            })}
        </Carousel>
      ) : (
        <div className="facility-photo-container">
          <img
            alt={facilityName}
            className="facility-street-map-view"
            data-testid="facility-photo-map-view"
            src={facilityStreetImgUrl}
          />
          {facilityVideoUrl && (
            <IonIcon
              onClick={() => setShowFacilityVideo(true)}
              data-testid="facility-photo-play-icon"
              className="facility-photo-play"
              icon={playIcon}
            />
          )}
        </div>
      )}
      {showFacilityVideo && facilityVideoUrl && (
        <FullScreenVideoPlayer
          onClose={() => setShowFacilityVideo(false)}
          onVideoEventListener={logVideoEvent}
          streamUrl={facilityVideoUrl}
          title={facilityName ?? ""}
        />
      )}
    </>
  );
}
